import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import Icon from "vue-awesome/components/Icon";
import App from "./App.vue";

import "vue-awesome/icons/brands/github-alt";
import "vue-awesome/icons/brands/linkedin-in";
import "vue-awesome/icons/envelope";
import "vue-awesome/icons/phone";
import "vue-awesome/icons/user-tie";
import "vue-awesome/icons/at";
import "vue-awesome/icons/compass";
import "vue-awesome/icons/university";
import "vue-awesome/icons/briefcase";
import "vue-awesome/icons/brands/js";
import "vue-awesome/icons/server";
import "vue-awesome/icons/drafting-compass";
import "vue-awesome/icons/mobile-alt";
import "vue-awesome/icons/calendar-alt";
import "vue-awesome/icons/podcast";
import "vue-awesome/icons/hands-helping";
import "vue-awesome/icons/download";

import "./assets/styles.scss";

import router from "./router";
import store from "./store";

Vue.component("v-icon", Icon);

Vue.use(BootstrapVue);

Vue.config.productionTip = false;

store.dispatch("FetchMe").then(() => {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
});
